<template>
  <div class="z-depth-2">
    <div  style="background-color: #00A492; color: white" class="py-3">
      <h3 class="text-center mb-3">Solicita tu demo</h3>
      <h2 class="text-center">Déjanos tus datos y te contactamos.</h2>
    </div>
    <form  class="p-4" @submit.prevent="sendEmail">
      <div class="row">

        <div class="col-lg-6 col-sm-12">
          <div class="form-group">
            <label for="name">Nombre:</label>
            <input class="form-control" name="name" id="name" type="text" v-model="name" required>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="form-group">
            <label for="subject">Telefono:</label>
            <input class="form-control" name="subject" id="subject" type="text" v-model="phone" required>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="form-group">
            <label for="email">Email:</label>
            <input class="form-control" name="email" id="email" type="email" v-model="email" required>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label for="message">Dejanos un mensaje con el producto de tu interes:</label>
            <textarea class="form-control w-100" name="message" id="message" cols="30" rows="9" v-model="message" required></textarea>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <button type="submit" class="btn" style="color: white">Enviar</button>
      </div>
      <div class="row justify-content-center">
        <span :class="classColor" >{{resp}}</span>
      </div>

    </form>
  </div>
</template>

<script>
  import {sendEmail} from "../API"

  export default {
    name: "FormContact",
    data(){
      return{
        name:'',
        email:'',
        phone:'',
        message:'',
        resp:'',
        classColor:''
      }
    },
    methods:{

      sendEmail(){
        let data = {
          name:this.name,
          message:this.message,
          phone:this.phone
        }
        sendEmail({data,email:this.email,}).then(()=>{
          this.name = ''
          this.email = ''
          this.phone = ''
          this.message = ''
          this.resp = `Se ha enviado tu informacion de contacto`
          this.classColor = `text-success text-center h5`
          setTimeout(()=>{
            this.resp = ''
            this.classColor =''
          },5000)
        }).catch(()=>{
          this.name = ''
          this.email = ''
          this.phone = ''
          this.message = ''
          this.classColor = `text-danger text-center h5`
          this.resp = `Ocuurio un Error al mandar los datos, intenta mas tarde`
          setTimeout(()=>{
            this.resp = ''
            this.classColor =''
          },5000)
        })
      }
    },
  }
</script>

<style scoped>
  input,textarea{
    border: none;
    background-color: #D6D6D6;
    border-radius: initial;
  }
  input:focus{
    border: none;
    background-color: #D6D6D6;
    border-radius: initial;
  }
  textarea:focus{
    border: none;
    background-color: #D6D6D6;
    border-radius: initial;
  }
  button{
    background-color: #00A492;
    color: white;
  }
</style>
